<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="error" class="alert_success" v-if="alert_show_remain_lostqty === true">ยอดคงเหลือและสูญเสียรวมกันไม่ควรเกินยอดเบิก</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-card>
            <div class="pa-3">
                <v-row>
                    <v-col cols="12">
                        <div class="d-flex justify-space-between align-center">
                            <h3>แก้ไขล๊อตออก</h3>
                            <v-btn class="grad-primary-bg white--text" height="50" width="20%" @click="$router.push('/alllot')">
                                ย้อนกลับ
                            </v-btn>
                        </div>
                        <div class="grid_lot_detail_out_edit_list mt-2">

                            <div class="grid_lot_detail_out_edit_list">
                                <div>รหัสล๊อตออก</div>
                                <div>{{ lot_detail.lot_code }}</div>
                                <div>วันที่</div>
                                <div>{{ lot_detail.dateTime }}</div>
                            </div>

                            <div class="grid_lot_detail_out_edit_list">
                                <div>รหัสใบสั่งซื้ออ้างอิง</div>
                                <div>{{ lot_detail.refer }}</div>
                                <div>ผู้ตรวจสอบของออก</div>
                                <div>{{ lot_detail.user_name }}</div>
                            </div>
                        </div>
                        <div class="mt-2">
                            <v-form ref="form_add" @submit.prevent="lotOutUpdate()">
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th rowspan="2" class="text-center border_header_lot_detail_out_edit_list">
                                                รายการ
                                            </th>
                                            <th rowspan="2" class="text-center border_header_lot_detail_out_edit_list">
                                                ราคาต้นทุน
                                            </th>
                                            <th rowspan="2" class="text-center border_header_lot_detail_out_edit_list">
                                                ยอดเบิก
                                            </th>
                                            <th rowspan="2" class="text-center border_header_lot_detail_out_edit_list">
                                                คงเหลือ
                                            </th>
                                            <th rowspan="2" class="text-center border_header_lot_detail_out_edit_list">
                                                สูญเสีย
                                            </th>
                                            <th rowspan="2" class="text-center border_header_lot_detail_out_edit_list">
                                                ใช้
                                            </th>
                                            <th colspan="2" class="text-center border_header_lot_detail_out_edit_list">
                                                มูลค่ารวม
                                            </th>
                                        </tr>
                                        <tr>
                                            <th class="text-center border_header_lot_detail_out_edit_list">
                                                ใช้
                                            </th>
                                            <th class="text-center border_header_lot_detail_out_edit_list">
                                                ทิ้ง
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(detail,index) in data" :key="index">
                                            <td class="text-center border_header_lot_detail_out_edit_list">{{ detail.name }}</td>
                                            <td class="text-center border_header_lot_detail_out_edit_list">
                                                {{ detail.price }}
                                            </td>
                                            <td class="text-center border_header_lot_detail_out_edit_list">
                                                {{ currencyFormat(detail.quantity) }}
                                            </td>
                                            <td class="text-center border_header_lot_detail_out_edit_list" width="10%">
                                                <v-text-field type="number" @input="useAll(detail.id)" v-model="detail.remain" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกรายการที่ใช้']" required dense outlined></v-text-field>
                                            </td>
                                            <td class="text-center border_header_lot_detail_out_edit_list" width="10%">
                                                <v-text-field type="number" @input="useAll(detail.id)" v-model="detail.lose_qty" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกรายการที่ทิ้ง']" required dense outlined></v-text-field>
                                            </td>
                                            <td class="text-center border_header_lot_detail_out_edit_list">
                                               {{ currencyFormat(detail.use_all) }}
                                            </td>
                                            <td class="text-center border_header_lot_detail_out_edit_list">
                                                {{ currencyFormat(detail.use_all * detail.price) }}
                                            </td>
                                            <td class="text-center border_header_lot_detail_out_edit_list">
                                                {{ detail.lose_qty ? currencyFormat(detail.price * detail.lose_qty): currencyFormat(0) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-center border_header_lot_detail_out_edit_list pt-2 pb-2" colspan="8">
                                                <div class="error--text" v-if="amount_all > 0 && text_erroramount_all === false">** ยอดคงเหลือและสูญเสียรวมกันไม่ควรเกินยอดเบิก **</div>
                                                <v-btn color="#28ab28" type="submit" class="white--text" width="20%" height="50" :disabled="amount_all == 0 ? false : true">
                                                    บันทึก
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-form>
                        </div>
                    </v-col>
                </v-row>
            </div>
            <v-dialog v-model="open_alert_show_add" persistent max-width="600">
                <v-card>
                    <v-card-title>
                        สำเร็จ
                    </v-card-title>

                    <v-card-text>
                        แก้ไขล๊อตออกเรียบร้อย
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" text @click="confirmSuccess()">
                            ตกลง
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</div>
</template>

<script>
import inoutstockall from '@/api/stock/stocklist/inoutstockall.js'
import {
    currencyFormat
} from '@/helper/numberformat.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            open_alert_show_add: false,
            alert_show_remain_lostqty: false,
            lot_detail: null,
            data: [],
        }
    },
    methods: {
        currencyFormat,
        async lotOutDetail() {
            this.loading_page = true
            inoutstockall.lotOutDetail(this.$store.state.lotDetailOutEditId,2).then((response) => {
                if (response.data.successful === true) {
                    this.lot_detail = response.data.lot
                    response.data.lot_detail.forEach((detail) => {
                        let use_all = detail.quantity
                        use_all -= detail.remain
                        use_all -= detail.lose_qty
                        this.data.push({
                            id:detail.id,
                            name:detail.name,
                            price:detail.price,
                            quantity:detail.quantity,
                            remain: detail.remain,
                            use_qty: detail.use_qty,
                            lose_qty: detail.lose_qty,
                            use_all:use_all,
                        })
                    })
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async useAll(id){
           let out_zone_all = this.data.find((detail) => {
               return detail.id == id
           })
           out_zone_all.use_all = out_zone_all.quantity
           out_zone_all.use_all -= out_zone_all.remain
           out_zone_all.use_all -= out_zone_all.lose_qty
        },
        async lotOutUpdate() {
            if (this.$refs.form_add.validate()) {
                let checkAll = false
                this.data.forEach((detail) => {
                    let all_remain_lostqty = parseFloat(detail.remain) + parseFloat(detail.lose_qty)
                    if (all_remain_lostqty > detail.quantity) {
                        checkAll = true
                    }
                })
                if (checkAll === true) {
                    this.alert_show_remain_lostqty = true
                    setTimeout(() => this.alert_show_remain_lostqty = false, 5000)
                } else {
                    this.loading_page = true

                    const id = this.data.map((detail) => {
                        return detail.id
                    })

                    const quantity = this.data.map((detail) => {
                        return parseFloat(detail.quantity)
                    })

                    const remain = this.data.map((detail) => {
                        return parseFloat(detail.remain)
                    })

                    const use_qty = this.data.map((detail) => {
                        return parseFloat(detail.use_all)
                    })

                    const lose_qty = this.data.map((detail) => {
                        return parseFloat(detail.lose_qty)
                    })

                    const use_price = this.data.map((detail) => {
                        return parseFloat(detail.use_all)  * parseFloat(detail.price)
                    })

                    const throw_away_price = this.data.map((detail) => {
                        return parseFloat(detail.price) * parseFloat(detail.lose_qty)
                    })

                    const data = {
                        lot_detail_id: id,
                        quantity: quantity,
                        remain: remain,
                        lose: lose_qty,
                        use_qty:use_qty,
                        use_price: use_price,
                        throw_away_price: throw_away_price,
                    }
                    inoutstockall.lotOutUpdate(this.$store.state.lotDetailOutEditId, data).then((response) => {
                        if (response.data.successful === true) {
                            this.open_alert_show_add = true
                            this.loading_page = false
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }
            }
        },
        async confirmSuccess() {
            this.$router.push('/alllot')
        },
    },
    computed: {
        amount_all() {
            let check_val = 0
            this.data.forEach((detail) => {
                let val_all = parseFloat(detail.remain) + parseFloat(detail.lose_qty)
                if (val_all > detail.quantity) {
                    check_val += 1
                }
                if (detail.remain === null || detail.lose_qty === null || detail.remain === '' || detail.lose_qty === '') {
                    check_val += 1
                }
            })
            
            return check_val
        },
        text_erroramount_all(){
            let check_val = false
            this.data.forEach((detail) => {
                if (detail.remain === null || detail.lose_qty === null || detail.remain === '' || detail.lose_qty === '') {
                    check_val = true
                }
            })

            return check_val
        }
    },
    mounted() {
        this.lotOutDetail()
    },
}
</script>

<style scoped>
.grid_lot_detail_out_edit_list {
    display: grid;
    grid-template-columns: auto auto;
}

.border_header_lot_detail_out_edit_list {
    border: thin solid rgba(0, 0, 0, 0.12);
}
</style>
